import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IdParams } from 'types/api'
import { ITenderCommissionMember } from 'types/tender/tenderCommissionMember'

export const tenderCommissionMembersApi = createApi({
  reducerPath: 'tenderCommissionMembers',
  baseQuery,
  endpoints: (builder) => ({
    tenderCommissionMembers: builder.query<ITenderCommissionMember[], void>({
      query: () => ({
        url: '/tender-commission-members',
      }),
    }),

    tenderCommissionMember: builder.query<ITenderCommissionMember, IdParams>({
      query: ({ id }) => `/tender-commission-members/${id}`,
    }),

    createTenderCommissionMember: builder.mutation<
      ITenderCommissionMember,
      Partial<ITenderCommissionMember>
    >({
      query: (body) => ({
        url: `/tender-commission/${body.id}/members`,
        body,
        method: 'post',
      }),
    }),

    updateTenderCommissionMember: builder.mutation<
      ITenderCommissionMember,
      Partial<ITenderCommissionMember>
    >({
      query: (body) => ({
        url: `/tender-commission-members/${body.id}`,
        body,
        method: 'put',
      }),
    }),

    deleteTenderCommissionMember: builder.mutation<void, IdParams>({
      query: ({ id }) => ({
        url: `/tender-commission-members/${id}`,
        method: 'delete',
      }),
    }),
  }),
})

export const {
  useTenderCommissionMemberQuery,
  useTenderCommissionMembersQuery,
  useUpdateTenderCommissionMemberMutation,
  // useDeleteTenderCommissionMemberMutation,
  useCreateTenderCommissionMemberMutation,
} = tenderCommissionMembersApi
